import type { ReactElement } from 'react'

import { BaseLayout } from 'aem-libs-react-components/src/components/calculators/layouts/base-layout/BaseLayout'
import { useDynamicParams } from 'aem-libs-react-ts/src/hooks/useDynamicParams'

import { InputFields } from '../components/InputFields'
import { OutOfLimitResult } from '../components/OutOfLimitResult'
import { ResultBoard } from '../components/ResultBoard'
import { LOAN_AMOUNT_BOUNDARY_FOR_RESULT } from '../constants'
import { loansConsolidationStore } from '../store'
import type { LoansConsolidationParams } from '../types'

export const BurinkaConsolidationContainer = () => {
  const params = useDynamicParams<LoansConsolidationParams>()
  const values = loansConsolidationStore.useStoreData()

  const totalLoanAmount = values.loanAmount + values.extraLoanAmount
  const loanAmountBoundaryForResult = params.loanAmountBoundaryForResult ?? LOAN_AMOUNT_BOUNDARY_FOR_RESULT

  const renderFinalResultBoard = (): ReactElement => {
    if (totalLoanAmount > loanAmountBoundaryForResult) {
      return (
        <OutOfLimitResult>
          <div dangerouslySetInnerHTML={{ __html: params.maxLoanResultInfo }} />
        </OutOfLimitResult>
      )
    }
    return <ResultBoard />
  }

  return <BaseLayout inputComponent={<InputFields />} resultComponent={renderFinalResultBoard()} />
}
